import React from "react";

import {
  Alert,
  //   Button,
  //   CircularProgress,
  Grid,
  //   TextField,
  Typography
} from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// import toast from "react-hot-toast";

// import {
//   forgotPasswordStart,
//   resetError,
//   resetSuccess
// } from "../../../../redux-saga/redux/auth/authentication";
import useStyles from "./ForgotPasswordModal.styles";
import BrandLogo from "../../../../container/SportsBookNode/BrandLogo";
// import { validateEmail } from "../../../../utils/helper";

const ForgotPasswordModal = () => {
  const classes = useStyles();
  //   const dispatch = useDispatch();
  const { t } = useTranslation();

  //   const [userNameOrEmail, setuserNameOrEmail] = useState("");

  //   const { loading, success, error } = useSelector(
  //     (state) => state.authentication
  //   );

  //   const handleEmail = (e) => {
  //     setuserNameOrEmail(e.target.value);
  //   };

  //   const handleSendLink = () => {
  //     if (!validateEmail(userNameOrEmail)) {
  //       toast.error(
  //         t("COMMON.EMAIL_VALIDATION", {
  //           id: "EMAIL_VALIDATION"
  //         })
  //       );
  //       dispatch(resetError());
  //       return;
  //     }
  //     dispatch(
  //       forgotPasswordStart({
  //         userNameOrEmail
  //       })
  //     );
  //   };

  //   useEffect(() => {
  //     if (success) {
  //       dispatch(resetSuccess());
  //       handleCloseLogin();
  //     }

  //     if (error) {
  //       toast.error(error, {
  //         id: "ERROR"
  //       });
  //       dispatch(resetError());
  //     }
  //   }, [loading, success, error, dispatch, handleCloseLogin, t]);

  return (
    <div>
      <Grid className={classes.loginLogo}>
        <BrandLogo />
      </Grid>
      <Grid className={classes.loginContent}>
        <Typography variant="h5">{t("HEADER.FORGOT_PASSWORD")}</Typography>
      </Grid>
      <Alert variant="outlined" className={classes.alertMsg} severity="info">
        {/* {t("HEADER.ADMIN_FORGOT_PASSWORD_MSG_1")}
        <a className={classes.mailLink} href="mailto:admin@forrajes.com">
          &nbsp;{t("HEADER.ADMIN_FORGOT_PASSWORD_MSG_2")}&nbsp;
        </a>
        {t("HEADER.ADMIN_FORGOT_PASSWORD_MSG_3")} */}
        {t("HEADER.CONTACT_YOUR_AGENT")}
      </Alert>
      {/* <Grid className={classes.loginFormWrap}>
        <Grid className={classes.formGroup}>
          <TextField
            type="userNameOrEmail"
            id="userNameOrEmail"
            label={t("COMMON.EMAIL_ADDRESS")}
            variant="outlined"
            onChange={handleEmail}
          />
        </Grid>
        <Grid className={classes.authBtnWrap}>
          <Button
            className={classes.btnPrimary}
            onClick={handleSendLink}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size="1.5rem" />
            ) : (
              t("HEADER.SEND_LINK")
            )}
          </Button>
        </Grid>
      </Grid> */}
    </div>
  );
};

export default ForgotPasswordModal;
